import React from 'react';
import CrearSectores from '../../../components/insumos/sectores/CrearSectores';

const InsumosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <h1>Crear Sectores</h1>
      <br />
      <br />
      <CrearSectores />
    </div>
  );
};

export default InsumosPage;